export default __webpack_public_path__ + "static/media/close.d49f1697.svg";